<template>
    <div style="padding: 0px;padding-bottom: 50px;">
        <el-row :gutter="20" style="height: 420px;">
            <el-col :span="5" style="height: 100%;">
                <el-card shadow="always" class="mgb20" style="height:100%;">

                    <el-card v-for="(item, index) in leftgames" :key="index" shadow="hover" class="leftgame"
                        @click.native="selectGame(item)">
                        <div>
                            <img :src="item.GameIcon" class="gameicon" />
                            <div style="float: left;">
                                <div class="sgametitle1">{{ item.GameName }}</div>
                                <div class="sgametitle2">游戏账号</div>
                            </div>
                        </div>
                    </el-card>
                    <el-button type="warning" icon="el-icon-lx-cart" class="moregamesbtn"
                        @click="moreGames()">更多游戏</el-button>
                </el-card>
            </el-col>
            <el-col :span="14" style="height: 100%;">
                <el-carousel :interval="5000" arrow="never" class="carouselad">
                    <el-carousel-item class="subcarouselad">
                        <img src="../../assets/img/banner1.png" class="banner" />
                    </el-carousel-item>
                    <el-carousel-item class="subcarouselad">
                        <img src="../../assets/img/banner2.png" class="banner" />
                    </el-carousel-item>
                </el-carousel>
            </el-col>
            <el-col :span="5" style="height: 100%;">

                <el-card shadow="always" class="mgb20" style="height:160px;">
                    <div class="cardtitle">验证查询</div>
                    <el-card shadow="hover" class="carbtn" @click.native="onAccountsVerify(1)"> <img
                            src="../../assets/img/c1.png" class="btnicon" />
                        <div class="btntext">黑号查询</div>
                    </el-card>
                    <el-card shadow="hover" class="carbtn" style="margin-left: 20px;"
                        @click.native="onAccountsVerify(2)"> <img src="../../assets/img/c2.png" class="btnicon" />
                        <div class="btntext">账号验证</div>
                    </el-card>
                </el-card>
                <el-card shadow="always" class="card20" style="height:240px;">
                    <div class="cardtitle">公告</div>

                    <div class="ggContent" v-for="(notice, i) in notices" :key="notice.NoticeID"
                        @click="onBtnNotic(notice.NoticeID)"><i :class="`el-icon-lx-text`"></i>{{ notice.Title }}</div>
                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-card shadow="always">
                <div style="width: 200px;">
                    <img src="../../assets/img/icon1.png" class="titleImg" />
                    <div class="titleText">推荐账号</div>
                </div>
                <el-tabs v-model="activeName" @tab-click="tabClick">
                    <el-tab-pane :label="game.name" :name="game.id + ''" v-for="game in games" :key="game.id">
                        <div shadow="hover" v-for="goods in bestgoods" :key="goods.GoodsID" class="subgamecard"
                            @click="onGamedetails(goods)">
                            <div class="imgbox">
                                <img :src="goods.FirstImage" class="gameimg">
                            </div>
                            <div class="gametitle"><span class="gameName">{{ goods.GameName }}</span>
                                {{ goods.Details }}
                            </div>
                            <div class="bottomfix">
                                <img src="../../assets/img/hot.png" class="hoticon">
                                <span class="shareicon">{{ goods.LikeNum }}</span>
                                <span class="gameprice1"> {{ goods.Price }}</span>
                                <span class="gameprice2"> ¥</span>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <el-button class="morebtn" @click="moreGames()">更多<i
                        class="el-icon-arrow-right el-icon--right"></i></el-button>

            </el-card>
        </el-row>

    </div>
</template>

<script>
import Schart from "vue-schart";
import bus from "../common/bus.js";
import netutil from "../common/netutil.js";
import accounts from '../common/accounts.js';
export default {
    name: "index",
    data() {
        return {
            activeName: "1",
            leftgames: [],
            newgoods: [],
            bestgoods: [],
            bestgoods1: [],
            notices: [],
            games: [
                { "name": '王者荣耀', id: 1 },
                { "name": '和平精英', id: 45 },
                { "name": '原神', id: 5 },
                { "name": '穿越火线', id: 13 },
                { "name": '火影忍者', id: 42 },
                { "name": '穿越火线手游', id: 50 }
            ],
            imgurl: 'https://imgs.1701gt.com/'
        };
    },
    components: {

    },
    computed: {
        username() {
            return accounts.Accounts();
        },
        head() {
            return accounts.HeadImg();
        },
        isLogon() {
            return accounts.UserID() != 0;
        },


    },
    created() {
        this.handleListener();
        this.getGameList(4);
        this.getGoodsList(this.activeName);
        this.getNotice();
    },
    activated() {
        this.handleListener();
    },
    deactivated() {


    },
    methods: {
        onAccountsVerify(index) {
            this.$router.push('/verify?index=' + index);

        },
        moreGames() {
            this.$router.push('/games');
        },
        getGameList(max) {
            var self = this;
            var param = {
                max: max
            };
            netutil.get("public/getgamelist", param,
                function (data) {
                    self.leftgames = data.data0;

                },
                function (msg) {

                });
        },
        getGoodsList(gameid) {
            var self = this;
            var param = {
                gameid: gameid,
                max: 12,
                page: 0
            };
            netutil.get("public/getgoodslist", param,
                function (data) {
                    self.bestgoods = data.data0;

                    for (let i = 0; i < self.bestgoods.length; ++i) {
                        self.bestgoods[i].FirstImage = netutil.getImgPath(self.bestgoods[i].FirstImage);
                    }
                },
                function (msg) {

                });
        },

        tabClick() {
            this.getGoodsList(parseInt(this.activeName));
        },
        getNotice() {
            var self = this;
            var param = {};
            netutil.get("public/getnoticelist", param,
                function (data) {
                    self.notices = data.data0;
                },
                function (msg) {

                });
        },
        onBtnNotic(id) {
            this.$router.push('/about?index=2&id=' + id);
        },
        handleListener() {
            bus.$on("collapse", this.handleBus);

        },
        handleBus(msg) {

        },
        selectGame(game) {
            localStorage.setItem('SelectGame', JSON.stringify(game));
            this.$router.push('/selectgame?id=' + game.GameID);
        },

        onGamedetails(goods) {
            let href = window.location.href   //当前页面域名 
            let params = `gamedetails`   //跳转页面及传参
            let url = href.replace('home', params)   //替换
            url = `${url}?goodsid=${goods.GoodsID}`;

            console.log(url);
            window.open(url, '_blank')

        },

        handleCommand(command) {
            if (command == 'loginout') {
                localStorage.removeItem('UserID');
                localStorage.removeItem('SessionID');
                localStorage.removeItem('UserInfo');
                this.islogon = false
                //this.$router.push('/login');
            }
            else if (command == 'logon') {
                localStorage.removeItem('UserID');
                localStorage.removeItem('SessionID');
                localStorage.removeItem('UserInfo');
                this.islogon = false
                this.$router.push('/login');
            }
        },

    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}

.carouselad {
    height: 420px;
}

.subcarouselad {
    height: 420px;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}

.btnbuy {
    width: 240px;
    height: 60px;
    border-radius: 4px;
    font-size: 20px;
    font-weight: 400px !important;
    background-color: #ff8800;
    text-align: center;
    margin-top: 15px;
    margin-left: calc(50% - 120px);
}

.head {
    width: 100px;
    height: 100px;
    border-radius: 100%;
    margin-left: 20px;
}

.banner {
    width: 100%;
    height: 100%;
}

.el-card {
    border-radius: 20px;
}

.stitle1 {
    height: 30px;
    color: #383838;
    border-bottom: 0.5px solid #dadada;
    margin-bottom: 10px;
}

.carbtn {
    width: 84px;
    height: 84px;
    float: left;
    margin-top: 10px;
    border-radius: 10px;
    font-size: 16px;
    color: #515a66;
    cursor: pointer;
}

.btnicon {
    text-align: center;
    width: 40px;
    height: 40px;
    margin-left: calc(50% - 20px);
    margin-top: -10px;
}

.btntext {
    text-align: center;
    width: 140%;
    margin-left: -20%;
    font-size: 15px;
}

.demo-tabs>.el-tabs__content {
    padding: 20px;
    color: #6b778c;
    font-size: 32px;
    font-weight: 600;
}

.titleImg {
    float: left;
    margin-right: 30px;
    width: 60px;
}

.titleText {
    float: left;
    padding-right: 20px;
    font-size: 24px;
    text-align: left;
    padding-top: 15px;
    margin-left: -20px;
    transform: skew(-20deg, 0deg);
    color: #0077ff;
    font-weight: 600;
}

.morebtn {
    position: absolute;
    float: right;
    font-size: 20px;
    border: #ffffff;
    top: 20px;
    right: 20px
}

.morebtn:focus {
    background: #ffffff;
    border-color: #ffffff;
    color: #030303;
}

.morebtn:hover {
    background: #ffffff;
    border-color: #ffffff;
    color: #030303;
}

.morebtn:checked {
    background: #ffffff;
    border-color: #ffffff;
    color: #030303;
}



.subgamecard {
    width: 370px;
    float: left;
    height: 350px;
    margin: 10px;
    cursor: pointer;
    padding: 0px 0px !important;
    border: 1px solid #ededed;
    border-radius: 10px;
    overflow: hidden;


}

.subgamecard:hover {
    box-shadow: 2px 2px 6px rgba(161, 161, 161, 0.3);
}

.imgbox {
    width: 370px;
    height: 200px;

    overflow: hidden;
}


.gameimg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
    overflow: hidden;

}

.gameName {
    font-size: 14px;
    line-height: 24px;
    height: 24px;
    padding: 2px 4px;
    text-align: center;
    color: #ffffff;
    background-color: #ffaa00;
    border-radius: 4px;

}

.gametitle {
    font-size: 18px;

    height: 64px;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    padding: 8px 10px;
}

.bottomfix {
    height: 20px;
    padding: 8px 10px;
}

.gameprice1 {
    font-size: 32px;
    color: rgb(255, 51, 0);
    line-height: 60px;
    float: right;

}

.gameprice2 {
    font-size: 24px;
    color: rgb(255, 51, 0);
    float: right;
    padding-top: 20px;
    padding-right: 5px;
}


.shareicon {

    font-size: 24px;
    color: #8c8c8c;
    line-height: 32px;
    float: left;
    margin-top: 20px;
    margin-left: 4px;
}

.hoticon {
    width: 28px;
    height: 28px;
    margin-top: 20px;
    float: left;
}

.leftgame {
    width: 100%;
    height: 80px;
    margin-bottom: 2px;
    display: flex;
    cursor: pointer;

}

.leftgame:hover {
    padding-left: 5px;

}

.gameicon {
    width: 70px;
    height: 70px;
    float: left;
    border-radius: 10%;
    margin-top: -15px;
    margin-left: -15px;
}

.sgametitle1 {

    padding: 6px;
    font-size: 16px;
    font-weight: 600;
    color: #363636;
    margin-top: -10px;
}

.sgametitle2 {
    font-size: 14px;
    padding-left: 6px;
    color: #8b8b8b;
}

.moregamesbtn {
    width: 100%;
    height: 50px;
    margin-top: 5px;
    border-radius: 15px;
    background-color: #ff8800;
    font-size: 20px;
}

.clearfix {
    padding-left: 10px;
    padding-right: 10px;
    font-size: 20px;
    height: 10px;
    line-height: 10px;
    color: #5d5d5d;
}

.cardtitle {
    line-height: 20px;
    height: 20px;
    padding-bottom: 5px;
    color: #858585;
    border-bottom: 1px solid #dadada;
}



.ggContent {
    cursor: pointer;
    line-height: 30px;
    height: 30px;
    text-decoration: underline;
    text-underline-offset: 3px;
    color: #5d5d5d;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.ggContent:hover {
    color: #ff8800;
}
</style>
